import { render, staticRenderFns } from "./PS-info-modal.vue?vue&type=template&id=228293db"
import script from "./PS-info-modal.vue?vue&type=script&lang=js"
export * from "./PS-info-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports